import script from "./AvisoVue.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoVue.vue?vue&type=script&setup=true&lang=js"

import "./AvisoVue.vue?vue&type=style&index=0&id=3b853d14&lang=css"

const __exports__ = script;

export default __exports__